import { config } from '../config'

const CONDOMINIUM = 'condominium'
const DEFAULT_REQUEST_NAME = 'Property Information Request'
const DEFAULT_REQUEST_SHORT_NAME = 'PIR'

function getTerminology() {
  return config.pir?.terminology ?? {}
}

function getAssociationTerm() {
  return getTerminology().associationTerm === CONDOMINIUM ? CONDOMINIUM : 'strata'
}

function getRequestName() {
  return getTerminology().requestName || DEFAULT_REQUEST_NAME
}

function getRequestShortName() {
  return getTerminology().requestShortName || DEFAULT_REQUEST_SHORT_NAME
}

function getRequestPluralName() {
  const shortName = getRequestShortName()
  if (shortName === 'PIR') return 'PIRs'
  return `${shortName}s`
}

function getRequestIdLabel() {
  return `${getRequestShortName()} ID`
}

function getAssociationTitle() {
  return getAssociationTerm() === CONDOMINIUM ? 'Condominium' : 'Strata'
}

function getAssociationLower() {
  return getAssociationTerm() === CONDOMINIUM ? 'condominium' : 'strata'
}

function getAssociationLabel(suffix) {
  return `${getAssociationTitle()} ${suffix}`
}

function getBoardMemberRole() {
  return `${getAssociationTitle()} Board Member`
}

function formatBoardMemberRole(role) {
  if (role === 'Strata Board Member') return getBoardMemberRole()
  return role
}

function getAuthorizerHeading(authorizerRole) {
  if (authorizerRole === 'STRATA' && getAssociationTerm() === CONDOMINIUM) return 'Condominium Authorization'
  return `${authorizerRole} Authorization`
}

function getAuthorizerDialogTitle(action, authorizerRole) {
  if (authorizerRole === 'STRATA' && getAssociationTerm() === CONDOMINIUM) return `${action} Authorization - condominium`
  return `${action} Authorization - ${authorizerRole.toLowerCase()}`
}

function associationContact() {
  return `${getAssociationLower()} contact`
}

function getSameContactPhrase({ sameOwner, sameStrata }) {
  const contact = associationContact()
  if (sameOwner && !sameStrata) return 'owner'
  if (!sameOwner && sameStrata) return contact
  return `owner, ${contact},`
}

function getSameContactVerificationPhrase({ sameOwner, sameStrata }) {
  if (sameOwner && sameStrata) return `owner and ${associationContact()}`
  return getSameContactPhrase({ sameOwner, sameStrata })
}

export default {
  getAssociationTerm,
  getAssociationTitle,
  getAssociationLower,
  getAssociationLabel,
  getBoardMemberRole,
  formatBoardMemberRole,
  getAuthorizerHeading,
  getAuthorizerDialogTitle,
  getSameContactPhrase,
  getSameContactVerificationPhrase,
  getRequestName,
  getRequestShortName,
  getRequestPluralName,
  getRequestIdLabel
}
